import React, { useEffect } from "react";
import { BrowserRouter, Route,  Routes } from "react-router-dom";
import { getRoutesByRole } from "./routes/routes";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PrivateRoute from "./routes/PrivateRoute";
import { generateToke ,messaging } from "./saas/Component/NotificationsComponent";
import { onMessage } from "firebase/messaging";
import { persistor } from "./redux/store";

function App() {
  const details = JSON.parse(sessionStorage.getItem("userDetails")) || {};
  const role = details?.user?.role?.toLowerCase() || details?.user?.type?.toLowerCase() || "guest";
  // Get role-based routes
  const roleRoutes = getRoutesByRole(role);
  useEffect(() => {
    if( window.location.pathname == "/superadmin/login"){return}
    if (!details?.token && window.location.pathname != "/login") {
      window.location = "/login"
    }
  }, [])

  useEffect(() => {
    generateToke();
    persistor.purge();
    onMessage(messaging, (payload) => {
      toast.success(payload.notification.body);
    });
  }, []);

  return (
    <React.Fragment>
      <ToastContainer position="top-center" autoClose={1500} />
      <BrowserRouter>
        <Routes>
          {
            roleRoutes.map((page, index) => {
              return (
                <Route key={index} path={page.path} element={page.isPrivate ? <PrivateRoute element={page.element} /> : page.element} />
              )
            })
          }
        </Routes>
      </BrowserRouter>
    </React.Fragment>

  );
}
export default App;
